import { cva, type VariantProps } from "class-variance-authority";

export type ButtonVariants = VariantProps<typeof buttonVariants>;
export const buttonVariants = cva(
  "font-semibold rounded-xl cursor-pointer disabled:pointer-events-none inline-flex items-center justify-center gap-2 whitespace-nowrap transition-all",
  {
    variants: {
      color: {
        primary: [
          "[--text-solid:var(--color-primary-content)]",
          "[--bg-solid:var(--color-primary)]",
          "[--bg-solid-hover:var(--color-primary-hover)]",
          "[--bg-solid-active:var(--color-primary-active)]",
          "[--bg-solid-inverted-active:var(--color-primary-inverted-active)]",
          "[--bg-solid-inverted-hover:var(--color-primary-inverted-hover)]",
        ],
        warning: [
          "[--text-solid:var(--color-warning-content)]",
          "[--bg-solid:var(--color-warning)]",
          "[--bg-solid-hover:var(--color-warning-hover)]",
          "[--bg-solid-active:var(--color-warning-active)]",
          "[--bg-solid-inverted-active:var(--color-warning-inverted-active)]",
          "[--bg-solid-inverted-hover:var(--color-warning-inverted-hover)]",
        ],
        danger: [
          "[--text-solid:var(--color-danger-content)]",
          "[--bg-solid:var(--color-danger)]",
          "[--bg-solid-hover:var(--color-danger-hover)]",
          "[--bg-solid-active:var(--color-danger-active)]",
          "[--bg-solid-inverted-active:var(--color-danger-inverted-active)]",
          "[--bg-solid-inverted-hover:var(--color-danger-inverted-hover)]",
        ],
      },
      iconOnly: {
        true: "p-0! text-lg!",
        false: null,
      },
      size: {
        lg: "h-11 text-base px-5 py-3.5",
        md: "h-9 text-sm px-4 py-3",
        sm: "h-7 text-xs px-3 py-2 rounded-lg",
      },
      variant: {
        solid:
          "bg-(--bg-solid) text-(--text-solid) disabled:text-disabled-content disabled:bg-disabled-200 hover:bg-(--bg-solid-hover) active:bg-(--bg-solid-active)",
        outline:
          "disabled:border-disabled-200  border bg-base-100 disabled:text-disabled-content hover:text-(--bg-solid-hover) active:text-(--bg-solid-active) hover:bg-(--bg-solid-inverted-hover) active:bg-(--bg-solid-inverted-active) border-(--bg-solid) hover:border-(--bg-solid-hover) active:border-(--bg-solid-active) text-(--bg-solid)",
        ghost:
          "bg-transparent disabled:text-disabled-content hover:text-(--bg-solid-hover) active:text-(--bg-solid-active) hover:bg-(--bg-solid-inverted-hover) active:bg-(--bg-solid-inverted-active) text-(--bg-solid)",
      },
    },
    compoundVariants: [
      {
        size: "lg",
        iconOnly: true,
        class: "w-11",
      },
      {
        size: "md",
        iconOnly: true,
        class: "w-9",
      },
      {
        size: "sm",
        iconOnly: true,
        class: "w-7",
      },
    ],
    defaultVariants: {
      color: "primary",
      iconOnly: false,
      size: "md",
      variant: "solid",
    },
  },
);
